import api from '@utils/api';
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import customEventBus from '@common/scripts/libs/eventBus';
import { MinicartActionTypes } from './common.types';
import minicartSlice from './minicart.slice';
let previuslyScrolled = false;
const handlePreviouslyScrolled = () => {
    var _a;
    let header = document.querySelector('header');
    if (header === null || header === void 0 ? void 0 : header.classList.contains('scrolled')) {
        previuslyScrolled = true;
    }
    else {
        previuslyScrolled = false;
        (_a = document.querySelector('header')) === null || _a === void 0 ? void 0 : _a.classList.add('scrolled');
    }
};
function* handleFetchMinicartAfterUpdate(action) {
    handlePreviouslyScrolled();
    const minicart = (yield call(api.getMiniCart));
    yield put(minicartSlice.actions.updateMinicart(minicart));
    yield put(minicartSlice.actions.setJustAddedMinicart(action.payload.pid));
}
function* handleFetchMinicartAndOpen() {
    handlePreviouslyScrolled();
    let minicart = yield select((state) => state.minicart.minicart);
    if (minicart === undefined) {
        minicart = (yield call(api.getMiniCart));
        yield put(minicartSlice.actions.updateMinicart(minicart));
    }
    yield put(minicartSlice.actions.setHoveringMinicart());
}
function* handleUpdateMinicart(action) {
    var _a;
    const minicart = (yield call(api.getMiniCart));
    if (!((_a = action === null || action === void 0 ? void 0 : action.payload) === null || _a === void 0 ? void 0 : _a.fromBag)) {
        customEventBus.emit('bag:update', { fromMinicart: true });
    }
    if (minicart.numItems == 0) {
        yield put(minicartSlice.actions.setNotHoveringMinicart());
        yield put(minicartSlice.actions.setNotJustAddedMinicart());
    }
    yield put(minicartSlice.actions.updateMinicart(minicart));
}
function* handleCloseMinicart() {
    var _a;
    if (!previuslyScrolled) {
        (_a = document.querySelector('header')) === null || _a === void 0 ? void 0 : _a.classList.remove('scrolled');
    }
    yield put(minicartSlice.actions.setNotHoveringMinicart());
    yield put(minicartSlice.actions.setNotJustAddedMinicart());
}
function* handleHoveringMinicart() {
    yield put(minicartSlice.actions.setHoveringMinicart());
}
// if (action.payload.deleteSelection) {
/**
 * @desc Watches every specified action and runs effect method and passes action args to it
 */
function* watchFetchRequest() {
    yield takeEvery(MinicartActionTypes.FETCH_MINICART_AFTER_UPDATE, handleFetchMinicartAfterUpdate);
    yield takeEvery(MinicartActionTypes.FETCH_MINICART_AND_OPEN, handleFetchMinicartAndOpen);
    yield takeEvery(MinicartActionTypes.UPDATE_MINICART, handleUpdateMinicart);
    yield takeEvery(MinicartActionTypes.CLOSE_MINICART, handleCloseMinicart);
    yield takeEvery(MinicartActionTypes.HOVERING_MINICART, handleHoveringMinicart);
}
/**
 * @desc saga init, forks in effects, other sagas
 */
export default function* minicartSaga() {
    yield all([fork(watchFetchRequest)]);
}
